import { useNavigate } from "react-router-dom";

export default function KpiCard({
  label,
  value,
  sublabel,
  filter,
  leads,
  icon: Icon,
  iconBg = "bg-blue-50",
  iconColor = "text-blue-600",
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/leads-view", {
      state: {
        applyFilter: filter || "All",
        leads: leads,
      },
    });
  };

  return (
    <div
      // onClick={handleClick}
      className="bg-white border border-blue-50 rounded-2xl p-4 shadow-sm flex items-center justify-between cursor-pointer hover:shadow-md transition"
    >
      {/* Left Content */}
      <div className="flex flex-col gap-1">
        <div className="text-xs font-medium uppercase tracking-wide text-slate-500">
          {label}
        </div>

        <div className="text-2xl font-semibold text-slate-900">
          {value}
        </div>

        {sublabel && (
          <div className="text-xs text-slate-500 mt-1">
            {sublabel}
          </div>
        )}
      </div>

      {/* Icon */}
      {Icon && (
        <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${iconBg}`}>
          <Icon className={`w-5 h-5 ${iconColor}`} />
        </div>
      )}
    </div>
  );
}


// import { useNavigate } from "react-router-dom";

// export default function KpiCard({ label, value, sublabel, filter, leads }) {
//   const navigate = useNavigate();

//   const handleClick = () => {
//     navigate("/leads-view", {
//       state: {
//         applyFilter: filter || "All",
//         leads: leads,                // always send FULL leads
//       },
//     });
//   };

//   return (
//     <div
//       // onClick={handleClick}
//       className="bg-white border border-blue-50 rounded-2xl p-4 shadow-sm flex flex-col gap-1 cursor-pointer hover:shadow-md transition"
//     >
//       <div className="text-xs font-medium uppercase tracking-wide text-slate-500">
//         {label}
//       </div>

//       <div className="text-2xl font-semibold text-slate-900">{value}</div>

//       {sublabel && (
//         <div className="text-xs text-slate-500 mt-1">{sublabel}</div>
//       )}
//     </div>
//   );
// }





// export default function KpiCard({ label, value, sublabel }) {
//   return (
//     <div className="bg-white border border-blue-50 rounded-2xl p-4 shadow-sm flex flex-col gap-1">
//       <div className="text-xs font-medium uppercase tracking-wide text-slate-500">
//         {label}
//       </div>
//       <div className="text-2xl font-semibold text-slate-900">{value}</div>
//       {sublabel && (
//         <div className="text-xs text-slate-500 mt-1">{sublabel}</div>
//       )}
//     </div>
//   );
// }